var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"px-2 px-md-4",attrs:{"flat":""}},[_c('v-sheet',{staticClass:"d-flex align-center justify-center",attrs:{"height":"calc(100vh - 350px)"}},[_c('div',{staticClass:"grey-3--text text-md-h1 text-h3 font-weight-bold text-center"},[_vm._v(" COMING SOON ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }